import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ProjectsActionTypes } from './types'
import { fetchError, fetchSuccess, fetchByNameSuccess, fetchByNameError } from './actions'
import { db } from '../../components/firebase'
import StringHelper from '../../utils/StringHelper'
// import directories from '../../data/directories.json'
import RegExUtils from '../utils/RegExUtils'

export function* ConvertBodyToPage(body: string) {
  const mediaPattern = RegExUtils.mediaPattern;
  const splitPattern = RegExUtils.splitPattern;
  const labelPattern = RegExUtils.label;
  const titlePattern = RegExUtils.titlePattern;
  const removePatterns = RegExUtils.removePatterns;
  // console.log('before', body)
  removePatterns.map((pattern, index) => {
    // console.log('pattern ' + pattern, body, body.match(pattern))
    body = body.replace(pattern, '')
  })
  // console.log('after', body)
  body = body.replace(/\.<\/strong>/gi, '.</strong> ')
  body = body.replace(/\.<\/b>/gi, '.</b> ')

  const tablePattern = /<table.+>([\s\S]*?)<\/table>/gim
  const noEmptyPattern = /<td+>\w+<\/td>/gim

  let mediaMatch = body.match(mediaPattern)
  let titleMatch = body.match(labelPattern)
  let mediaArr = []
  //match up all media

  // let parser = new DOMParser()
  // var doc = parser.parseFromString(blog.data().body, 'text/html')
  // console.log('mediaMatch', doc.body, doc.getElementsByName('iframe'), mediaMatch)
  // console.log('mediaMatch', mediaMatch)
  if (mediaMatch != null) {
    for (let i = 0; i < mediaMatch.length; i++) {
      // add a split patterns into the body
      body = body.replace(mediaMatch[i], splitPattern)
      let media = mediaMatch[i]
      let src =
        media.match(RegExUtils.imagePattern) != null
          ? media.match(RegExUtils.imagePattern)[0]
          : ''
      let alt =
        media.match(RegExUtils.altPattern) != null
          ? media.match(RegExUtils.altPattern)[0]
          : ''
      // console.log('src', src)
      let mediaType = 'image'
      if (src.indexOf('youtube') != -1) {
        mediaType = 'youtube'
      } else if (src.indexOf('vimeo') != -1) {
        mediaType = 'vimeo'
      } else if (src.indexOf('flickr') != -1) {
        mediaType = 'flickr'
      }
      let mediaObj = {
        type: mediaType,
        url: mediaType == 'flickr' ? src.match(RegExUtils.flickrPattern)[0] : src,
        label: mediaType == 'image' ? alt : titleMatch != null ? titleMatch[i] : ''
      }
      mediaArr.push(mediaObj)
    }
  }
  // console.log('mediaArr', mediaArr)
  //split the body into pages
  let pageArrX = body.split(splitPattern)
  let pageArr = []
  //clear out empty parts
  for (let i = 0; i < pageArrX.length; i++) {
    let p = RegExUtils.Sanitize(pageArrX[i]);
    let trimmed = p.replace(/<.*?>/gi, '').trim()
    let parser = new DOMParser()
    var doc = parser.parseFromString(trimmed, 'text/html')
    if (doc.body.innerText.trim() == '') {
      trimmed = ''
    }
    if (trimmed != '') {
      pageArr.push(p)
    } else {
      pageArr.push('')
    }
  }

  var pages = []
  // console.log('pageArr', pageArr)
  for (let i = 0; i < pageArr.length; i++) {
    let pageBody = pageArr[i]
    pageBody = RegExUtils.Sanitize(pageBody.replace(labelPattern, '');
    // console.log('page', pageBody)

    const table = pageBody.match(tablePattern)
    // console.log(table)
    if (table != null) {
      // console.log(table[0].match(noEmptyPattern))
      let parser = new DOMParser()
      var doc = parser.parseFromString(table[0], 'text/html')
      if (doc.body.innerText.trim() == '') {
        pageBody = pageBody.replace(tablePattern, '')
      }
    }
    let title = ''
    if (pageBody.match(titlePattern) != null) {
      title = pageBody.match(titlePattern).length != -1 ? pageBody.match(titlePattern)[0] : ''
    }
    title = title.replace(/<br>/gi, '')
    let obj = {
      theme: i % 2 == 0 ? 'light' : 'dark',
      title: title,
      subtitle: '',
      body: pageBody
    }
    // console.log('mediaArr[' + i + ']', mediaArr[i])
    if (mediaArr[i] != undefined) {
      obj['media'] = mediaArr[i]
    }
    // console.log(obj['media'] == '', obj['body'] == '')
    let mediatype = ''
    if (obj['media'] != undefined) mediatype = obj['media']['type']
    if (obj['body'] == '' && pages.length > 0 && mediatype == 'image') {
      if (obj['media'] != undefined) {
        let curpage = pages[pages.length - 1]
        let curmed = curpage['media']

        if (!Array.isArray(curmed)) {
          curmed = [curmed]
        }
        curmed.push(obj['media'])
        // console.log('====', curpage, curmed, obj['media'])
        curpage['media'] = curmed
      }
    } else {
      if (obj['body'] == '' && obj['media'] == undefined) {
      } else {
        pages.push(obj)
      }
    }
  }
  // Check page consistency
  // console.log("P{AGES", pages);
  let pagesConsitent = []
  for (let i = 0; i < pages.length; i++) {
    if (i + 1 < pages.length) {
      // console.log((pages[i+1]['body']!="") +"&&"+ (pages[i+1]['media']===undefined) +"&&"+ (pages[i]["media"]!=undefined) +"&&"+ (pages[i]["body"]==""))
      if (
        pages[i + 1]['body'] != '' &&
        pages[i + 1]['media'] === undefined &&
        pages[i]['media'] != undefined &&
        pages[i]['body'] === ''
      ) {
        pages[i]['body'] = pages[i + 1]['body']
        pages[i + 1]['body'] = ''
      }
    }
    if (pages[i]['body'] != '' || pages[i]['media'] != undefined) {
      pagesConsitent.push(pages[i])
    }
  }

  pages = pagesConsitent
  if (pages.length == 0) {
    // console.log('no pages to create')
  } else {
    // console.log(
    //   'PAGES Consitent',
    //   pages[0].hasOwnProperty('media')
    //     ? Array.isArray(pages[0].media)
    //       ? pages[0].media[0]
    //       : pages[0].media
    //     : undefined
    // )
    let updateObj = { pages: pages }
    if (pages[0].hasOwnProperty('media')) {
      updateObj['cover'] = Array.isArray(pages[0].media) ? pages[0].media[0] : pages[0].media
    }
    // console.log('--->')
    return updateObj
  }
  return pages
}

export function* UpdateImages(item: any) {
  const regex = /(userdata\/)([\/|.|\w|\s|-])*\.(?:jpg|gif|png)/gi
  const storageRef = db.storageRef()
  const replaceLower = directories

  let images = []
  let imagesToReplace = []
  if (item.data().body.match(regex) != null) {
    let str = ''
    item
      .data()
      .body.match(regex)
      .map(m => {
        str = m
        replaceLower.map(folder => {
          str = str.replace('/' + folder + '/', '/' + folder.toLowerCase() + '/')
        })
        if (str.indexOf('/sonicimpairment/') != -1) {
          str = str.replace('/sonicimpairment/', '/projects/sonicimpairment/')
        }
        if (str.indexOf('/electronics/') != -1) {
          str = str.replace('/electronics/', '/experiments/electronics/')
        }
        if (str.indexOf('/glowingbacteria/') != -1) {
          str = str.replace('/glowingbacteria/', '/experiments/glowingbacteria/')
        }
        if (str.indexOf('/cressecosystem/') != -1) {
          str = str.replace('/cressecosystem/', '/experiments/cressecosystem/')
        }
        if (str.indexOf('/greenhouse/') != -1) {
          str = str.replace('/greenhouse/', '/experiments/greenhouse/')
        }
        if (str.indexOf('/tissueculture/') != -1) {
          str = str.replace('/tissueculture/', '/experiments/tissueculture/')
        }
        if (str.indexOf('/playingwithbacteria/') != -1) {
          str = str.replace('/playingwithbacteria/', '/experiments/playingwithbacteria/')
        }

        imagesToReplace.push({ updated: str, original: m })
        // calls.push(call(FindStorageURL(storageRef, str)()))
      })
    let imageStorage = []
    for (let img of imagesToReplace) {
      const result = yield call(FindStorageURL, storageRef, img.updated)
      result.original = img.original
      imageStorage.push(result)
    }

    // console.log(storageRef, str, result)
    let body = item.data().body
    for (let i of imageStorage) {
      body = body.replace(i.original, i.url)
    }
    images.push({ images: imageStorage, item: item, body: body })
  }

  return images
}

function* FindStorageURL(storageRef: any, str: string) {
  // console.log('FindStorageURL')
  let image = storageRef.child(str)
  let promise = () =>
    image.getDownloadURL().then(url => {
      // console.log(url)

      return {
        url,
        str
      }
    })
  const result = yield promise()
  return result
}
function* getBlob(localFile) {
  return fetch(localFile)
    .then(function(response) {
      console.log(response)
      return response.blob()
    })
    .then(function(blob) {
      // coverref.put(blob).then(snapshot => {
      //   coverref.getDownloadURL().then(url => {
      //     return url
      //   })
      // })
      return blob
    })
}
export function* Upload(localFile) {
  if (localFile == null) return
  const storageRef = db.storageRef()
  // console.log('localFile', localFile)
  localFile = localFile.toString().replace('~', '')
  let coverref = storageRef.child(localFile.toLowerCase())
  // let blob = yield call(getBlob, localFile)
  // console.log(blob)
  // return coverref.put(blob).then(snapshot => {
  //   //   coverref.getDownloadURL().then(url => {
  //   //     return url
  //   //   })
  // })

  return fetch(localFile)
    .then(function(response) {
      // console.log(response)
      return response.blob()
    })
    .catch(err => console.log('error', err, localFile))
    .then(function(blob) {
      return coverref.put(blob).then(snapshot => coverref.getDownloadURL())
    })
    .catch(err => console.log('error', err, localFile))
}
